<template>
    <div class="block-editor show-widget">
        <div class="wrapper">
            <section>
                <div class="title">User ID</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor v-model="clone.userId" automation-mode />
                </div>
            </section>
            <section >
                <div class="title">User Session ID</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor v-model="clone.sessionId" automation-mode />
                </div>
            </section>
            <section>
                <div class="title">Title</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        placeholder="Type Title"
                        :show-attributes="true"
                        :show-emoji="true"
                        :max-character-count="1024"
                        v-model="clone.title"
                        automation-mode
                    />
                </div>
            </section>
            <section>
                <div class="title">Mode</div>
                <a-select v-model="clone.mode" default-value="url">
                    <a-select-option value="url">URL</a-select-option>
                    <a-select-option value="html">HTML</a-select-option>
                </a-select>
            </section>
            <section v-if="clone.mode === 'url'">
                <div class="title">URL</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor v-model="clone.url" automation-mode />
                </div>
            </section>
            <section v-if="clone.mode === 'html'">
                <div class="title">HTML Content</div>
                <div id="monaco-html-editor-container" class="monaco-html-editor-container"></div>
            </section>
            <section>
                <div class="title">Full Screen Mode</div>
                <a-switch v-model="clone.fullScreen" />
            </section>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import * as monaco from "monaco-editor";
import { CHATBOT_API } from "../../../../../../api/chatbotv2";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../components/pickers/CustomPicker.vue";
import { mapState } from "vuex";

const log = log2("Showwidget");
export default {
    name: "Showwidget",
    components: { TiptapEditor, CustomPicker },
    props: ["value"],
    data() {
        const value = this.value || {};
        return {
            clone: {
                userId: value.userId || "",
                sessionId: value.sessionId || "",
                title: value.title || "",
                url: value.url || "",
                fullScreen: value.fullScreen || false,
                mode: value.mode || "url", // Geriye dönük uyumluluk için default "url"
                html: value.html || ""
            },
            editor: null,
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {
        initMonaco() {
            if (this.clone.mode === "html") {
                this.$nextTick(() => {
                    const container = document.getElementById("monaco-html-editor-container");
                    if (container && !this.editor) {
                        this.editor = monaco.editor.create(container, {
                            value: this.clone.html || "",
                            language: "html",
                            theme: "vs-dark",
                            minimap: {
                                enabled: false,
                            },
                            automaticLayout: true,
                            scrollBeyondLastLine: false,
                            lineNumbers: "on",
                            roundedSelection: true,
                            cursorStyle: "line",
                            wordWrap: "on",
                            tabSize: 2,
                            fontSize: 14,
                            formatOnPaste: true,
                            formatOnType: true,
                        });

                        this.editor.onDidChangeModelContent(() => {
                            this.clone.html = this.editor.getValue();
                        });
                    }
                });
            }
        },
        destroyMonaco() {
            if (this.editor) {
                this.editor.dispose();
                this.editor = null;
            }
        },
        handleResize() {
            if (this.editor) {
                this.editor.layout();
            }
        },
    },
    mounted() {
        this.initMonaco();
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        this.destroyMonaco();
        window.removeEventListener("resize", this.handleResize);
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        "clone.mode": {
            handler(newMode) {
                if (newMode === "html") {
                    this.destroyMonaco();
                    this.$nextTick(() => {
                        this.initMonaco();
                    });
                } else {
                    this.destroyMonaco();
                }
            },
        },
    },
    async created() {
    },
};
</script>

<style lang="scss">
.block-editor.show-widget {
    section {
        margin-bottom: 10px;
    }

    .wrapper {
        padding: 30px;

        .title {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .form-picker-wrapper {
            background: white;
            border-radius: 0px;
            border: 1px solid #fff;

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .monaco-html-editor-container {
            width: 100%;
            height: 300px;
            border-radius: 5px;
            overflow: hidden;
            margin-top: 10px;
            border: 1px solid #ddd;
        }
    }
}
</style>
